export const aiCampaignKeys = {
	all: ['aiCampaigns'],
	status: (campaignId) => [...aiCampaignKeys.all, 'status', campaignId],
	emailsAll: (campaignId) => [...aiCampaignKeys.all, 'emails', campaignId],
	emails: (campaignId) => [...aiCampaignKeys.all, 'emails', campaignId, 'infinite'],
	pendingContacts: (campaignId) => [...aiCampaignKeys.all, 'pending-contacts', campaignId],
};
